<div class="wrapper-restricted"> 
<div class="container-restricted">
  <div class="logo-access">
    <img src="assets/images/asoban-access.png" alt="asoban" />
  </div>
  <router-outlet (activate)="onActivate()"> </router-outlet>
  <app-side-calendar (openSidebar)="actionSidebar($event)"></app-side-calendar>
</div>
</div>
